// bundleApi.ts
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export interface Bundle {
  id: number;
  prod_name: string;
  prod_desc: string;
  product_retail_price: string;
  product_main_image: string | null;
  product_unit: string;
  product_quantity: number;
  product_stock: number;
}

export interface BundleResponse {
  success: boolean;
  data: Bundle[];
}

export const bundleApi = createApi({
  reducerPath: 'bundleApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_SERVER_ENDPOINT,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('admin_token');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      headers.set(
        'authkey',
        '7b4e1fd03f57885c1ff900ad76ea3810bb7160c7157a4c31cf2de3'
      );
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  }),
  tagTypes: ['Bundle'],
  endpoints: (build) => ({
    listBundles: build.query<BundleResponse, {}>({
      query: () => ({
        url: 'user/listbundles',
        method: 'POST',
        body: {},
      }),
      providesTags: ['Bundle'],
    }),
   // Update the addBundle endpoint in your bundleApi.ts:

addBundle: build.mutation({
  query: (bundleData) => {
    // Validate required fields before sending
    const requiredFields = [
      'prod_name',
      'prod_desc', 
      'product_retail_price',
      'product_quantity',
      'product_stock',
      'product_unit',
      // Add the mainstream required fields from your screenshot:
      'mainstream_status', // or whatever field name is used
      'warehouse_id', // based on your UI
    ];
    
    const missingFields = requiredFields.filter(field => 
      !bundleData[field] && bundleData[field] !== 0
    );
    
    if (missingFields.length > 0) {
      throw new Error(`Missing required fields: ${missingFields.join(', ')}`);
    }
    
    return {
      url: 'user/addbundles',
      method: 'POST',
      body: bundleData,
    };
  },
  invalidatesTags: ['Bundle'],
}),
    deleteBundle: build.mutation({
      query: (bundle_id) => ({
        url: 'user/deletebundles',
        method: 'POST',
        body: { bundle_id },
      }),
      invalidatesTags: ['Bundle'],
    }),
  }),
});

export const {
  useListBundlesQuery,
  useAddBundleMutation,
  useDeleteBundleMutation,
} = bundleApi;